'use strict';

(function () {
  if (customElements.get('showcase-scroller')) return;

  class ShowcaseScroller extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.observer = null;
      this.resizeTimer = null;
      this.slider = this.querySelector('.swiper');
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.slider = this.slider || this.querySelector('.swiper');

      if (this.dataset.enableCarousel !== 'true' || !this.slider) return;

      if (!('IntersectionObserver' in window)) {
        this.initSwiper();
        window.addEventListener('resize', this.handleResize);
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;

          this.observer.disconnect();
          this.observer = null;
          this.initSwiper();
          window.addEventListener('resize', this.handleResize);
        },
        { rootMargin: '200px' },
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      window.removeEventListener('resize', this.handleResize);
      window.clearTimeout(this.resizeTimer);
      this.destroySwiper();
    }

    initSwiper() {
      if (!this.slider || this.swiper || typeof Swiper === 'undefined') return;

      const slidesLength =
        Number(this.dataset.slidesLength) ||
        this.querySelectorAll('.swiper-slide').length;

      if (slidesLength < 1) return;

      const requestedMobileView = Number(this.dataset.slidesPerView) || 1.2;
      const requestedDesktopView = Number(this.dataset.slidesPerViewLg) || 3;
      const slidesPerView = Math.min(requestedMobileView, slidesLength);
      const slidesPerViewLg = Math.min(requestedDesktopView, slidesLength);
      const slidesPerViewMd = Math.min(
        (slidesPerView + slidesPerViewLg) / 2,
        slidesLength,
      );
      const largestSlidesPerView = Math.max(
        slidesPerView,
        slidesPerViewMd,
        slidesPerViewLg,
      );

      const spaceBetween = Number(this.dataset.spaceBetween) || 16;
      const spaceBetweenMd =
        Number(this.dataset.spaceBetweenMd) || spaceBetween;
      const spaceBetweenLg =
        Number(this.dataset.spaceBetweenLg) || spaceBetweenMd;
      const autoplayEnabled =
        slidesLength > 1 && this.dataset.autoplay === 'true';
      const loopEnabled =
        this.dataset.loop === 'true' &&
        slidesLength > Math.ceil(largestSlidesPerView);
      const scrollbar = this.querySelector('.swiper-scrollbar');

      const swiperParams = {
        speed: 700,
        slidesPerView,
        spaceBetween,
        loop: loopEnabled,
        rewind: !loopEnabled,
        watchOverflow: true,
        grabCursor: true,
        autoplay: autoplayEnabled
          ? {
              delay: Number(this.dataset.autoplayDelay) || 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: this.dataset.pauseOnHover !== 'false',
            }
          : false,
        breakpoints: {
          750: {
            slidesPerView: slidesPerViewMd,
            spaceBetween: spaceBetweenMd,
          },
          990: {
            slidesPerView: slidesPerViewLg,
            spaceBetween: spaceBetweenLg,
          },
        },
      };

      if (scrollbar) {
        swiperParams.scrollbar = {
          el: scrollbar,
          draggable: true,
        };
      }

      this.swiper = new Swiper(this.slider, swiperParams);
    }

    destroySwiper() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    handleResize() {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => {
        if (this.swiper) {
          this.swiper.update();
        } else {
          this.initSwiper();
        }
      }, 200);
    }
  }

  customElements.define('showcase-scroller', ShowcaseScroller);
})();
